import React, {FunctionComponent, useEffect, useMemo, useState} from 'react';
import styles from './BarItem.module.css';
import {colourObj} from "../../data/colours";
import ChartLabelExpandedForBar from "../chart-label-expanded-for-bar/ChartLabelExpandedForBar";

const sum = (a: number, b: number) => a + b;

const BarItem: FunctionComponent<{ values: any[], index: number, oldVal: number }> = (
  {
    values,
    index,
    oldVal,
  }) => {

  const item: [string, number] = useMemo(() => Object.entries(values[index])[0] as [string, number], [index, values]);

  const [width, setWidth] = useState(0);

  const alignRight = useMemo(() => {
    if (index === 0) {
      return false;
    }
    const currentTotalVal = values.slice(0, index + 1).map((obj) => Object.values(obj)[0] as number).reduce(sum);
    if (currentTotalVal > 65) {
      return true;
    }
  }, [index, values]);

  useEffect(() => {
    requestAnimationFrame(() => {
      setWidth(item[1] as number);
    });
  }, [item]);

  const displayBar = useMemo(() => (Object.values(values[index])[0] as unknown as number) > 0, [index, values]);

  const position = useMemo(() => {
    if (index === 0) {
      return 0;
    }
    const itemValues = values.map(obj => Object.values(obj)[0]);
    const itemsToAddUp = Array.from(new Array(index)).map((_, i) => itemValues[i] as number);
    return itemsToAddUp.reduce(sum);
  }, [index, values]);

  return (
    displayBar ?
      <div
        style={{
          width: width + "%",
          left: position + "%",
          backgroundColor: colourObj[item[0]],
        }}
        className={styles.barItem}
      >
        <span className={styles.legend} style={{color: item[0] === "prepared" ? "#063025" : "white"}}>{item[1]}%</span>
        <div className={styles.legendOverlay}>
            <ChartLabelExpandedForBar val={item[1]} oldVal={oldVal} color={colourObj[item[0]]} alignRight={alignRight}/>
        </div>
      </div>
      : null
  );
}

export default BarItem;
